import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dashToDot',
  pure: true
})
export class DashToDotPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/_/g, '.');
  }
}
